<template>
  <v-card>
    <v-card-title class="pl-dialog__title">
      <h4>Смена статуса</h4>
    </v-card-title>

    <v-card-text>
      <v-select v-model="currentStatus" :items="items" item-text="name" item-value="value" item-avatar="color">
        <template slot="item" slot-scope="props">
          <v-avatar :color="props.item.color" class="pl-flex-margin-right15" size="20"></v-avatar>
          {{ props.item.name }}
        </template>
        <template slot="selection" slot-scope="props">
          <v-avatar :color="props.item.color" class="pl-flex-margin-right15" size="20"></v-avatar>
          {{ props.item.name }}
        </template>
      </v-select>
      <v-select
        v-show="currentStatus != 1"
        v-model="reason"
        :items="reasons"
        item-text="name"
        placeholder="Причина"
        item-value="value"
        item-avatar="color"
      >
      </v-select>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="pl-btn pl-btn_primary" @click="changeStatus"> Сохранить </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Vue from 'vue'
import store from '@/store/index'
import { mapGetters } from 'vuex'

export default {
  name: 'EmployerSipStatusesModal',

  data: () => ({
    currentStatus: 1,
    reason: null,
    reasons: [
      { name: 'Вызов к руководству', value: 2 },
      { name: 'Перерыв', value: 3 },
      { name: 'Нерабочее время', value: 4 },
    ],
    items: Vue.config.modules.crm.staticData.employerActivityStatusesModal,
  }),

  computed: {
    ...mapGetters(['userStatus']),
  },

  methods: {
    changeStatus() {
      store.commit('setUserStatus', +this.currentStatus)
      store.commit('setOpenedSettings', false)
    },
  },
}
</script>
